export default __webpack_public_path__ + "static/richer-f44b3c5482e08ec3fdfc78b1aed72a28.png";